<div class="session-verification-container">
  <div class="session-verification-content">
    <div *ngIf="loading" class="loading-section">
      <div class="spinner"></div>
      <h2>{{'auth.verifying_your_session' | translate}}</h2>
      <p>{{'auth.please_wait' | translate}}</p>
    </div>

    <div *ngIf="!loading && errorMessage" class="error-section">
      <div class="error-icon">
        <i class="fa fa-exclamation-circle"></i>
      </div>
      <h2>{{'auth.sessions_verification_failed' | translate}}</h2>
      <p>{{ errorMessage }}</p>
    </div>
  </div>
</div>
